import Vue from 'vue'
import moment from 'moment'

moment.locale('pt-BR')
Vue.filter('formatDatetime', value => {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
  return null
})

Vue.filter('formatDate', value => {
  if (value) {
    return moment(String(value))
      .utcOffset('+0000')
      .format('DD/MM/YYYY')
  }
  return null
})

Vue.filter('formatSmallDate', value => {
  if (value) {
    return moment(String(value)).format('DD/MM/YY')
  }
  return null
})

Vue.filter('daysMonth', value => {
  if (value) {
    return moment(String(value))
      .format('DD/MMM')
      .toUpperCase()
  }
  return null
})

Vue.filter('monthOnly', value => {
  if (value) {
    return moment(String(value))
      .format('MMM')
      .toUpperCase()
  }
  return null
})

Vue.filter('dayOnly', value => {
  if (value) {
    return moment(String(value))
      .format('DD')
      .toUpperCase()
  }
  return null
})

Vue.filter('daysPast', value => {
  if (value) {
    return moment.duration(moment().diff(moment(String(value)))).humanize()
  }
  return null
})

Vue.filter('currencyBRL', value => {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
  })
  return formatter.format(value)
})

Vue.filter('byteToMegabyte', value => {
  if (typeof value !== 'number') {
    return value
  }
  const sizeInMB = (value / (1024 * 1024)).toFixed(2)

  return `${sizeInMB}mb`
})

Vue.filter('CpfCnpj', documentId => {
  if (!documentId) return documentId

  documentId = typeof documentId !== 'string' ? documentId.toString() : documentId

  documentId = documentId.replace(/\D/g, '')

  if (documentId.length === 14) {
    documentId = documentId.padStart(14, '0')
    documentId = documentId.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      '$1.$2.$3/$4-$5',
    )
  } else {
    documentId = documentId.padStart(11, '0')
    documentId = documentId.replace(
      /^(\d{3})(\d{3})(\d{3})(\d{2})/,
      '$1.$2.$3-$4',
    )
  }
  return documentId
})
